module.exports = __webpack_public_path__ + "static/banner-isometric2-050d60938e5d98388712573740e607f4.png";